import { Routes } from '@angular/router';
import { authGuard } from './guards/auth-guard'

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
    canActivate: [authGuard]
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage),
    canActivate: [authGuard]
  },
  {
    path: 'absence',
    loadComponent: () => import('./pages/absence/absence.page').then(m => m.AbsencePage),
    canActivate: [authGuard]
  },
  {
    path: 'chat/:roomId',
    loadComponent: () => import('./pages/chat/chat.page').then(m => m.ChatPage),
    canActivate: [authGuard]
  },
  {
    path: 'external-link',
    loadComponent: () => import('./pages/external-link/external-link.page').then(m => m.ExternalLinkPage)
  },

];
